import imgSrc from '../javascripts/imgSrc'
let tw = {
    postureHome: {
        indexPage: {
            a_posture_title: "體態分析報告",
            show: "1"
        },
        coverInfo: {
            customerName: "測試對象",
            date: "報告日期",
            time: "檢測時間",
            userName: "檢測分析師",
            clickEnterReport: "點擊進入報告"
        }
    },
    postureIpad: {
        bullet: {
            Home: '首頁',
            Posturedata: '體態數據',
            Score: '風險評估',
            Muscle: '肌肉狀態',
            Solution: '報告結論'
        },
        front: '正視圖',
        side: '側視圖',
        viwesNav: '側面 | 正面',
        InvalidData: '數據無效',
        qrcode: '長按保存圖片，打開微信客戶端掃描二維碼',
        expertsWalk: '步姿專家',
        smallProgram: '小程序',
        clickRightTop: '點擊右上角',
        clickTranspond: '點擊[轉發]分享小程序',
        symptoms: {
            head: [
                {
                    name: '頭部側傾',
                    key: 'headSidesway',
                    normal: {
                        left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
                        right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
                        normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
                        right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
                    },
                    definition: '在直立過程中，頭部向左或右傾斜的現象。',
                    harm: {
                        bone: '頸椎側屈',
                        muscle: '屈曲側：胸鎖乳突肌縮短緊張、斜角肌縮短緊張、頭夾肌縮短緊張、肩胛提肌縮短緊張、頸夾肌緊張。拉長側：胸鎖乳突肌拉長、斜角肌拉長、頸夾肌拉長、肩胛提肌拉長',
                        neurovascular: '單側椎動脈受壓迫、單側頸神經受壓迫',
                        des: '長期使脖子側歪容易使頸後韌帶以及肌肉的慢性勞損，導致椎骨增生，頸椎病。'
                    },
                    risks: [
                        {
                            name: '肌肉韌帶慢性勞損',
                            des: '長期頭側傾容易導致頸後韌帶、頸周圍肌肉的慢性勞損。'
                        },
                        {
                            name: '頸椎病',
                            des: '由於頭部異位導致頸部軟組織、骨骼的異常，增大了頸椎病患病風險。'
                        }
                    ]
                },
                {
                    name: '頭部前傾',
                    key: 'headLean',
                    normal: {
                        normal: imgSrc.risk_normal.HEAD_LEAN
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.HEAD_LEAN
                    },
                    definition: '頭部過度向前伸的現象。',
                    harm: {
                        bone: '椎弓變直或出現反弓',
                        muscle: '胸鎖乳突縮短緊張、斜方肌上束過度拉長、夾肌（頭夾肌、頸夾肌）過度拉長、肩胛提肌緊張、斜角肌縮短緊張',
                        neurovascular: '胸鎖乳突肌--副神經可誘發面部疼痛，椎弓變直使椎間孔間隙變小壓迫頸部神經和椎動脈，斜方肌過度縮短可能壓迫鎖骨下動脈導致手臂供血不足',
                        des: '頭部每前傾出2.5厘米，頸部多增加4千克重量負擔，向前伸出6-9厘米，頸部的負荷已經超過了20升水的重量，頭部前傾還會引發頭暈、搖晃、眼睛裏面疼痛、惡心、食欲不振、長期的頸椎病、肩周炎和偏頭痛、思考能力下降、腹壓降低、腰椎不穩、壓迫神經，緊張性頭痛、肺活量降低，影響心血管健康、血液循環變慢，影響大腦血供、影響形象美觀。'
                    },
                    risks: [
                        {
                            name: '頭暈頭痛',
                            des: '頭部前傾可能影響頭部血液循環，由於血流不暢而導致頭部缺氧，引發頭暈頭痛。'
                        },
                        {
                            name: '頸椎病',
                            des: '長期的重度頭部前傾可能會導致頸椎病。'
                        },
                        // {
                        //   name: '腰椎不穩',
                        //   des: '由於頭部前傾引發頸椎受力異常，由此引發整個脊柱的受力異常。'
                        // },
                        // {
                        //   name: '心腦血管疾病',
                        //   des: '頭部的異位可能影響頭部血液循環，危害心腦血管健康。'
                        // }
                    ]
                }
            ],
            shoulder: [
                {
                    name: '高低肩',
                    key: 'highLowShoulder',
                    normal: {
                        left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                        right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                        normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                        right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                    },
                    definition: '肩峰左右高度差超過2CM則為高低肩。',
                    harm: {
                        bone: '脊柱側彎、骨盆側傾、長短腿、高側肩胛骨上擡、單側足弓塌陷',
                        muscle: '高側：肩胛提肌縮短緊張、斜方肌上束縮短緊張、菱形肌緊張、斜角肌縮短緊張、胸小肌拉長、鎖骨下肌緊張、前鋸肌拉長緊張。低側：',
                        neurovascular: '',
                        des: '肩膀附近的肌肉過緊，或者由於脊柱側彎導致的脊柱變形，因此容易產生頸肩部位的慢性疼痛、慢性頭痛、高低肩使姿勢不正確，使得頸椎所承受的負荷量過重，最後可能導致頸椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部組織肌力不平衡，導致腰痛。同時，骨盆移位也會使腿長發生變化。'
                    },
                    risks: [
                        {
                            name: '慢性頭痛',
                            des: '長期的高低肩容易產生頸肩部位、頭部的慢性疼痛。'
                        },
                        {
                            name: '骨刺',
                            des: '高低肩使頸椎受力異常，最後可能導致頸椎部位退化，易形成骨刺。'
                        },
                        {
                            name: '腰痛',
                            des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，導致腰痛。'
                        },
                        {
                            name: '長短腿',
                            des: '由於高低肩造成的骨盆移位可能會使腿長發生變化。'
                        }
                    ]
                },
                {
                    name: '圓肩',
                    key: 'roundShoulder',
                    normal: {
                        normal: imgSrc.risk_normal.ROUND_SHOULDER
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.ROUND_SHOULDER
                    },
                    definition: '由於胸小肌被動縮短，肩胛骨前引，使肩部向前和向下，造成圓肩的現象。',
                    harm: {
                        bone: '肩胛骨外展、胸廓變小',
                        muscle: '胸大肌、胸小肌縮短緊張、菱形肌過度拉長、斜方肌拉長',
                        neurovascular: '',
                        des: '圓肩會影響個人形象、氣質欠佳、緊張的肌肉會造成肩頸酸痛，最嚴重可壓迫頸椎神經，引起頭痛和手臂麻木。頸部曲度減小，僵硬，引起對大腦供血不足，使人整天灰灰沈沈，打不起精神。圓肩會使橫膈膜處於緊張狀態，造成大動脈和腔靜脈的壓迫，使心臟工作負擔加重。'
                    },
                    risks: [
                        {
                            name: '心臟負擔加重',
                            des: '過度圓肩會使橫膈膜處於緊張狀態，造成大動脈和腔靜脈被壓迫，使心臟工作負擔加重。'
                        },
                        {
                            name: '頭痛',
                            des: '肩頸周圍肌肉緊張，嚴重時可致頸椎神經被壓迫，引起頭痛。'
                        },
                        {
                            name: '手臂麻木',
                            des: '肩頸周圍肌肉緊張，嚴重時可致頸椎神經被壓迫，引起手臂麻木。'
                        }
                    ]
                }
            ],
            trunk: [
                {
                    name: '脊柱異位',
                    key: 'spineSidesway',
                    normal: {
                        left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
                        right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
                        normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
                        right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
                    },
                    definition: '是指脊柱的壹個或數個節段向側方彎曲伴有椎體旋轉的三維脊柱畸形的現象。',
                    harm: {
                        bone: '脊柱出現S型彎曲或C型彎曲',
                        muscle: '凹側肌肉縮短無力、凸側肌肉拉長無力松弛',
                        neurovascular: '',
                        des: '脊柱側彎會發作肩背不平，腿腳不等長，駝背雞胸，身材矮小，活動範圍減小。胸廓變形、腹腔減小等造成腰背痛痛、神經受損、消化不良、心跳反常、肢體感覺障礙等癥狀。消化不良，食欲不振、肺-血液氣體交換功能障礙，高低肩，肩頸部的不適，、消化不良，食欲不振，心搏加速，心慌意亂，氣短，胸腹脹滿，四肢肌肉無力，四肢反應敏感度不同，體力較弱等.'
                    },
                    risks: [
                        {
                            name: '脊柱側彎',
                            des: '平面拍攝檢測出脊柱異位提示您需進壹步通過三維檢測，確定是否存在脊柱側彎的癥狀。'
                        },
                        {
                            name: '高低肩',
                            des: '脊柱側彎可能伴隨高低肩癥狀。'
                        },
                        {
                            name: '骨盆側傾',
                            des: '脊柱側彎可能伴隨骨盆側傾癥狀。'
                        }
                    ]
                }
            ],
            pelvis: [
                {
                    name: '骨盆側傾',
                    key: 'pelvisLean',
                    normal: {
                        left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
                        right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
                        normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
                        right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT,
                    },
                    definition: '在X光片上顯示的兩側髂脊的上緣連線不在同壹條水平線上，觸診時兩手卡在髂脊上緣出現壹手高壹手低的現象。',
                    harm: {
                        bone: '骨盆傾斜',
                        muscle: '高側：腰方肌縮短緊張、高髂腰縮短肌緊張、臀中肌縮短緊張，臀大肌緊張。低側：臀大肌薄弱、腰方肌拉長無力、髂腰肌拉長無力',
                        neurovascular: '',
                        des: '骨盆側傾可能會引發腰腿疼痛、坐骨神經痛、腰椎間盤突出、臀肌或腿部肌肉萎縮、脊椎側彎、胸部疼痛、高低肩，長短腿，雙腿並攏的時候可能膝蓋還不壹個高度，痛經，肩頸疼痛。'
                    },
                    risks: [
                        {
                            name: '慢性疼痛',
                            des: '骨盆側傾可能會引發腰腿疼痛、肩頸疼痛。'
                        },
                        {
                            name: '腰椎間盤突出',
                            des: '骨盆側傾可能加重腰椎間盤突出風險。'
                        },
                        {
                            name: '長短腿',
                            des: '骨盆側傾可能加重長短腿風險。。'
                        }
                    ]
                }
            ],
            'lower extremity': [
                {
                    name: 'O型腿',
                    key: 'legO',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_O
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_O
                    },
                    definition: '是指兩下肢自然伸直或站立時，兩足內踝能相碰而兩膝不能靠攏。',
                    harm: {
                        bone: 'O型腿（膝內翻）',
                        muscle: '髖外旋肌緊張、髖內旋肌無力、臀大肌薄弱、股骨前傾角過大',
                        neurovascular: '',
                        des: '下肢臃腫之感、外側肌肉發達，而內側肌肉菲薄、膝關節內側軟骨面磨損，脛骨平臺塌陷，繼發骨性關節炎，O型腿也會影響體型外觀。'
                    },
                    risks: [
                        {
                            name: '半月板損傷',
                            des: 'O型腿造成下肢力線發生改變，膝關節內側間隙承受大於正常負荷的壓力。可能引起膝關節內側半月板損傷。'
                        },
                        {
                            name: '關節炎',
                            des: '嚴重O型腿最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節\n' +
                                '置換手術。'
                        }
                    ]
                },
                {
                    name: 'X型腿',
                    key: 'legX',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_X
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_X
                    },
                    definition: '指兩足並立時，兩側膝關節碰在壹起，而兩足內踝無法靠攏。',
                    harm: {
                        bone: 'X型腿（膝外翻）',
                        muscle: '髖外展肌無力、股四頭肌內側頭、髖內旋肌緊張、股二頭肌緊張、髂脛束緊張',
                        neurovascular: '',
                        des: '影響美觀，給人的心理造成壹定的自卑感、膝內翻使下肢的力線發生改變，膝關節內側間隙承受大於正常負荷的壓力，長此以往，引起膝關節內側間隙關節退變，最終可能發展為膝關節骨性關節炎引起疼痛，引起膝關節外側間隙關節退變，嚴重者需要進行人工關節置換手術。'
                    },
                    risks: [
                        {
                            name: '半月板損傷',
                            des: 'X型腿造成下肢力線發生改變，膝關節外側間隙承受大於正常負荷的壓力。可能引起膝關節外側半月板損傷。'
                        },
                        {
                            name: '關節炎',
                            des: '嚴重X型腿最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節\n' +
                                '置換手術。'
                        }
                    ]
                },
                {
                    name: '膝過伸',
                    key: 'kneeOverstretch',
                    normal: {
                        normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
                    },
                    definition: '在行走或站立過程中，下肢在支撐期出現膝關節過度伸展（膝伸展角度大於5°），身體重心後移，髖關節過度屈曲，身體出現後傾趨勢的現象。',
                    harm: {
                        bone: '踝關節背屈不足，使膝關節無法向前移動',
                        muscle: '臀大肌薄弱、較多情況下股四頭較肌薄弱，腘繩肌過度活躍，踝關節周圍韌帶緊張、膝關節周圍韌帶及關節囊松弛',
                        neurovascular: '',
                        des: '膝關節伸展受限、膝關節控制能力差、下肢深感覺障礙、異常的運動模式。'
                    },
                    risks: [
                        {
                            name: '膝關節退變',
                            des: '長期膝關節過伸，會引起膝關節的過度磨損，加大膝關節退變的發生率。'
                        },
                        {
                            name: '損害全身平衡',
                            des: '膝關節位置的改變會引起髖關節、骨盆、踝關節的位置異常，由此逐漸損害全身的平衡狀態，長期累積會引發各種體態異常。'
                        }
                    ]
                },
                {
                    name: 'XO型腿',
                    key: 'legXO',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_XO
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_XO
                    },
                    definition: '股骨、脛骨均呈內旋位，雙側小腿不能並攏。',
                    harm: {
                        bone: '這個是XO型腿',
                        muscle: '這個是XO型腿',
                        neurovascular: '',
                        des: 'XO型腿，股骨、脛骨均呈內旋位，雙側小腿間存在較大間隙，不能並攏，影響美觀。由於股骨與脛骨位置相對不平衡，壓力更易集中在膝關節外側，更易發生膝關節疼痛甚至膝關節炎。'
                    },
                    risks: [
                        {
                            name: '膝關節疼痛',
                            des: '由於XO型腿造成股骨與脛骨位置相對不平衡，壓力更易集中在膝關節外側，更易發生膝關節疼痛。'
                        },
                        {
                            name: '膝關節炎',
                            des: '重度XO型腿最終可能發展為膝關節骨性關節炎。'
                        }
                    ]
                }
            ],
        }
    },
    postureModalIpad: {
        detection: "檢測到",
        item: "項",
        noHeightRisk: "恭喜您未檢測到高風險，請繼續保持良好的體態",
        otherDetecation: "其他檢測項",
        potentialRisk: "潛在風險",
        heightRisk: "高風險",
        suggest: "平時需要關註自己的體態,並且加強鍛煉",
        suggestSolve: "出現了較明顯的異常體態,需要及時尋求解決方案或是獲取更多專業咨詢",
        normal: "正常",
        risk: "風險",
        return: "返回",
        levelName: "高 | 中 | 低"
    },
    postureModal: {
        goback: "返回",
        potentialRisk: "潛在風險",
        levelName: "高 | 中 | 低",
        symptominterpretation: "癥狀解讀",
        triggersymptoms: "引發癥狀",
        normal: "正常",
        highRisk: "高風險"
    },
    postureReport: {
        redAlert: "紅色代表此部分肌肉緊張",
        yellowAlert: "黃色代表此部分肌肉薄弱",
        muscleDire: {
            normal: "正常",
            face: "正面肌肉",
            side: "側面肌肉",
            back: "背面肌肉"
        },
        details: {
            lh: "lh",
            ll: "ll",
            rh: "rh",
            rr: "rr"
        },
        descripName: {
            upName: "需加強",
            lowName: "需放松"
        },
        navList: "正面 | 側面 | 背面",
        boneDescription: {
            face: {
                trunk: "腹部肌群",
                legForX: ["髖外旋肌", "髖內收肌"],
                legForO: "髖外旋肌",
                legForStretch: "股四頭肌",
                round: "胸大肌"
            },
            side: {
                round: "胸鎖乳突肌",
                fore: "胸鎖乳突肌",
                shoulder: "斜角肌"
            },
            back: {
                spine: "高側斜方肌",
                shoulder: "高側斜方肌",
                round: ["高側斜方肌", "低側斜方肌"],
                fore: ["高側斜方肌", "低側斜方肌"],
                rake: "肩胛提肌",
                legStretch: ["腘繩肌", "足底筋膜"],
                legX: ["髖外旋肌", "股二頭肌"],
                legO: ["半腱肌半膜肌", "脛骨前肌、脛骨後肌"],
                legXO: ["股二頭肌", "足底筋膜"]
            }
        }
    },
    postureSymp: {
        detection: '檢測到',
        item: '項',
        noHeightRisk: '恭喜您未檢測到高風險，請繼續保持良好的體態',
        otherDetecation: '其他檢測項',
        potentialRisk: '潛在風險',
        heightRisk: '高風險',
        suggest: '平時需要關註自己的體態,並且加強鍛煉',
        suggestSolve: '出現了較明顯的異常體態,需要及時尋求解決方案或是獲取更多專業咨詢',
        normal: '正常',
        risk: '風險',
    },
    postureSympIpad: {
        detection: "檢測到",
        item: "項",
        noHeightRisk: "恭喜您未檢測到高風險，請繼續保持良好的體態",
        otherDetecation: "其他檢測項",
        potentialRisk: "潛在風險",
        heightRisk: "高風險",
        suggest: "平時需要關註自己的體態,並且加強鍛煉",
        suggestSolve: "出現了較明顯的異常體態,需要及時尋求解決方案或是獲取更多專業咨詢",
        normal: "正常",
        risk: "風險"
    },
    posture: {
        bullet: {
            Home: '首頁',
            Posturedata: '體態數據',
            Score: '風險評估',
            Muscle: '肌肉狀態',
            Solution: '報告結論'
        },
        viwesNav: '側面 | 正面',
        InvalidData: '數據無效',
        qrcode: '長按保存圖片，打開微信客戶端掃描二維碼',
        expertsWalk: '步姿專家',
        smallProgram: '小程序',
        clickRightTop: '點擊右上角',
        clickTranspond: '點擊[轉發]分享小程序',
        symptoms: {
            head: [
                {
                    name: '頭部側傾',
                    key: 'headSidesway',
                    normal: {
                        left: imgSrc.risk_normal.HEAD_SIDESWAY_LEFT,
                        right: imgSrc.risk_normal.HEAD_SIDESWAY_RIGHT,
                        normal: imgSrc.risk_normal.HEAD_SIDESWAY_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.HEAD_SIDESWAY_LEFT,
                        right: imgSrc.risk_abnormal.HEAD_SIDESWAY_RIGHT
                    },
                    definition: '在直立過程中，頭部向左或右傾斜的現象。',
                    harm: {
                        bone: '頸椎側屈',
                        muscle: '屈曲側：胸鎖乳突肌縮短緊張、斜角肌縮短緊張、頭夾肌縮短緊張、肩胛提肌縮短緊張、頸夾肌緊張。拉長側：胸鎖乳突肌拉長、斜角肌拉長、頸夾肌拉長、肩胛提肌拉長',
                        neurovascular: '單側椎動脈受壓迫、單側頸神經受壓迫',
                        des: '長期使脖子側歪容易使頸後韌帶以及肌肉的慢性勞損，導致椎骨增生，頸椎病。'
                    },
                    risks: [
                        {
                            name: '肌肉韌帶慢性勞損',
                            des: '長期頭側傾容易導致頸後韌帶、頸周圍肌肉的慢性勞損。'
                        },
                        {
                            name: '頸椎病',
                            des: '由於頭部異位導致頸部軟組織、骨骼的異常，增大了頸椎病患病風險。'
                        }
                    ]
                },
                {
                    name: '頭部前傾',
                    key: 'headLean',
                    normal: {
                        normal: imgSrc.risk_normal.HEAD_LEAN
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.HEAD_LEAN
                    },
                    definition: '頭部過度向前伸的現象。',
                    harm: {
                        bone: '椎弓變直或出現反弓',
                        muscle: '胸鎖乳突縮短緊張、斜方肌上束過度拉長、夾肌（頭夾肌、頸夾肌）過度拉長、肩胛提肌緊張、斜角肌縮短緊張',
                        neurovascular: '胸鎖乳突肌--副神經可誘發面部疼痛，椎弓變直使椎間孔間隙變小壓迫頸部神經和椎動脈，斜方肌過度縮短可能壓迫鎖骨下動脈導致手臂供血不足',
                        des: '頭部每前傾出2.5厘米，頸部多增加4千克重量負擔，向前伸出6-9厘米，頸部的負荷已經超過了20升水的重量，頭部前傾還會引發頭暈、搖晃、眼睛裏面疼痛、惡心、食欲不振、長期的頸椎病、肩周炎和偏頭痛、思考能力下降、腹壓降低、腰椎不穩、壓迫神經，緊張性頭痛、肺活量降低，影響心血管健康、血液循環變慢，影響大腦血供、影響形象美觀。'
                    },
                    risks: [
                        {
                            name: '頭暈頭痛',
                            des: '頭部前傾可能影響頭部血液循環，由於血流不暢而導致頭部缺氧，引發頭暈頭痛。'
                        },
                        {
                            name: '頸椎病',
                            des: '長期的重度頭部前傾可能會導致頸椎病。'
                        },
                        // {
                        //   name: '腰椎不穩',
                        //   des: '由於頭部前傾引發頸椎受力異常，由此引發整個脊柱的受力異常。'
                        // },
                        // {
                        //   name: '心腦血管疾病',
                        //   des: '頭部的異位可能影響頭部血液循環，危害心腦血管健康。'
                        // }
                    ]
                }
            ],
            shoulder: [
                {
                    name: '高低肩',
                    key: 'highLowShoulder',
                    normal: {
                        left: imgSrc.risk_normal.HIGH_LOW_SHOULDER_LEFT,
                        right: imgSrc.risk_normal.HIGH_LOW_SHOULDER_RIGHT,
                        normal: imgSrc.risk_normal.HIGH_LOW_SHOULDER_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_LEFT,
                        right: imgSrc.risk_abnormal.HIGH_LOW_SHOULDER_RIGHT
                    },
                    definition: '肩峰左右高度差超過2CM則為高低肩。',
                    harm: {
                        bone: '脊柱側彎、骨盆側傾、長短腿、高側肩胛骨上擡、單側足弓塌陷',
                        muscle: '高側：肩胛提肌縮短緊張、斜方肌上束縮短緊張、菱形肌緊張、斜角肌縮短緊張、胸小肌拉長、鎖骨下肌緊張、前鋸肌拉長緊張。低側：',
                        neurovascular: '',
                        des: '肩膀附近的肌肉過緊，或者由於脊柱側彎導致的脊柱變形，因此容易產生頸肩部位的慢性疼痛、慢性頭痛、高低肩使姿勢不正確，使得頸椎所承受的負荷量過重，最後可能導致頸椎部位退化，易形成骨刺。高低肩造成骨盆的移位，使腰部組織肌力不平衡，導致腰痛。同時，骨盆移位也會使腿長發生變化。'
                    },
                    risks: [
                        {
                            name: '慢性頭痛',
                            des: '長期的高低肩容易產生頸肩部位、頭部的慢性疼痛。'
                        },
                        {
                            name: '骨刺',
                            des: '高低肩使頸椎受力異常，最後可能導致頸椎部位退化，易形成骨刺。'
                        },
                        {
                            name: '腰痛',
                            des: '高低肩可能造成骨盆的移位，使腰部肌力不平衡，導致腰痛。'
                        },
                        {
                            name: '長短腿',
                            des: '由於高低肩造成的骨盆移位可能會使腿長發生變化。'
                        }
                    ]
                },
                {
                    name: '圓肩',
                    key: 'roundShoulder',
                    normal: {
                        normal: imgSrc.risk_normal.ROUND_SHOULDER
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.ROUND_SHOULDER
                    },
                    definition: '由於胸小肌被動縮短，肩胛骨前引，使肩部向前和向下，造成圓肩的現象。',
                    harm: {
                        bone: '肩胛骨外展、胸廓變小',
                        muscle: '胸大肌、胸小肌縮短緊張、菱形肌過度拉長、斜方肌拉長',
                        neurovascular: '',
                        des: '圓肩會影響個人形象、氣質欠佳、緊張的肌肉會造成肩頸酸痛，最嚴重可壓迫頸椎神經，引起頭痛和手臂麻木。頸部曲度減小，僵硬，引起對大腦供血不足，使人整天灰灰沈沈，打不起精神。圓肩會使橫膈膜處於緊張狀態，造成大動脈和腔靜脈的壓迫，使心臟工作負擔加重。'
                    },
                    risks: [
                        {
                            name: '心臟負擔加重',
                            des: '過度圓肩會使橫膈膜處於緊張狀態，造成大動脈和腔靜脈被壓迫，使心臟工作負擔加重。'
                        },
                        {
                            name: '頭痛',
                            des: '肩頸周圍肌肉緊張，嚴重時可致頸椎神經被壓迫，引起頭痛。'
                        },
                        {
                            name: '手臂麻木',
                            des: '肩頸周圍肌肉緊張，嚴重時可致頸椎神經被壓迫，引起手臂麻木。'
                        }
                    ]
                }
            ],
            trunk: [
                {
                    name: '脊柱異位',
                    key: 'spineSidesway',
                    normal: {
                        left: imgSrc.risk_normal.SPINE_SIDESWAY_LEFT,
                        right: imgSrc.risk_normal.SPINE_SIDESWAY_RIGHT,
                        normal: imgSrc.risk_normal.SPINE_SIDESWAY_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.SPINE_SIDESWAY_LEFT,
                        right: imgSrc.risk_abnormal.SPINE_SIDESWAY_RIGHT
                    },
                    definition: '是指脊柱的壹個或數個節段向側方彎曲伴有椎體旋轉的三維脊柱畸形的現象。',
                    harm: {
                        bone: '脊柱出現S型彎曲或C型彎曲',
                        muscle: '凹側肌肉縮短無力、凸側肌肉拉長無力松弛',
                        neurovascular: '',
                        des: '脊柱側彎會發作肩背不平，腿腳不等長，駝背雞胸，身材矮小，活動範圍減小。胸廓變形、腹腔減小等造成腰背痛痛、神經受損、消化不良、心跳反常、肢體感覺障礙等癥狀。消化不良，食欲不振、肺-血液氣體交換功能障礙，高低肩，肩頸部的不適，、消化不良，食欲不振，心搏加速，心慌意亂，氣短，胸腹脹滿，四肢肌肉無力，四肢反應敏感度不同，體力較弱等.'
                    },
                    risks: [
                        {
                            name: '脊柱側彎',
                            des: '平面拍攝檢測出脊柱異位提示您需進壹步通過三維檢測，確定是否存在脊柱側彎的癥狀。'
                        },
                        {
                            name: '高低肩',
                            des: '脊柱側彎可能伴隨高低肩癥狀。'
                        },
                        {
                            name: '骨盆側傾',
                            des: '脊柱側彎可能伴隨骨盆側傾癥狀。'
                        }
                    ]
                }
            ],
            pelvis: [
                {
                    name: '骨盆側傾',
                    key: 'pelvisLean',
                    normal: {
                        left: imgSrc.risk_normal.PELVIS_LEAN_LEFT,
                        right: imgSrc.risk_normal.PELVIS_LEAN_RIGHT,
                        normal: imgSrc.risk_normal.PELVIS_LEAN_NORMAL
                    },
                    abnormal: {
                        left: imgSrc.risk_abnormal.PELVIS_LEAN_LEFT,
                        right: imgSrc.risk_abnormal.PELVIS_LEAN_RIGHT,
                    },
                    definition: '在X光片上顯示的兩側髂脊的上緣連線不在同壹條水平線上，觸診時兩手卡在髂脊上緣出現壹手高壹手低的現象。',
                    harm: {
                        bone: '骨盆傾斜',
                        muscle: '高側：腰方肌縮短緊張、高髂腰縮短肌緊張、臀中肌縮短緊張，臀大肌緊張。低側：臀大肌薄弱、腰方肌拉長無力、髂腰肌拉長無力',
                        neurovascular: '',
                        des: '骨盆側傾可能會引發腰腿疼痛、坐骨神經痛、腰椎間盤突出、臀肌或腿部肌肉萎縮、脊椎側彎、胸部疼痛、高低肩，長短腿，雙腿並攏的時候可能膝蓋還不壹個高度，痛經，肩頸疼痛。'
                    },
                    risks: [
                        {
                            name: '慢性疼痛',
                            des: '骨盆側傾可能會引發腰腿疼痛、肩頸疼痛。'
                        },
                        {
                            name: '腰椎間盤突出',
                            des: '骨盆側傾可能加重腰椎間盤突出風險。'
                        },
                        {
                            name: '長短腿',
                            des: '骨盆側傾可能加重長短腿風險。。'
                        }
                    ]
                }
            ],
            'lower extremity': [
                {
                    name: 'O型腿',
                    key: 'legO',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_O
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_O
                    },
                    definition: '是指兩下肢自然伸直或站立時，兩足內踝能相碰而兩膝不能靠攏。',
                    harm: {
                        bone: 'O型腿（膝內翻）',
                        muscle: '髖外旋肌緊張、髖內旋肌無力、臀大肌薄弱、股骨前傾角過大',
                        neurovascular: '',
                        des: '下肢臃腫之感、外側肌肉發達，而內側肌肉菲薄、膝關節內側軟骨面磨損，脛骨平臺塌陷，繼發骨性關節炎，O型腿也會影響體型外觀。'
                    },
                    risks: [
                        {
                            name: '半月板損傷',
                            des: 'O型腿造成下肢力線發生改變，膝關節內側間隙承受大於正常負荷的壓力。可能引起膝關節內側半月板損傷。'
                        },
                        {
                            name: '關節炎',
                            des: '嚴重O型腿最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節\n' +
                                '置換手術。'
                        }
                    ]
                },
                {
                    name: 'X型腿',
                    key: 'legX',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_X
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_X
                    },
                    definition: '指兩足並立時，兩側膝關節碰在壹起，而兩足內踝無法靠攏。',
                    harm: {
                        bone: 'X型腿（膝外翻）',
                        muscle: '髖外展肌無力、股四頭肌內側頭、髖內旋肌緊張、股二頭肌緊張、髂脛束緊張',
                        neurovascular: '',
                        des: '影響美觀，給人的心理造成壹定的自卑感、膝內翻使下肢的力線發生改變，膝關節內側間隙承受大於正常負荷的壓力，長此以往，引起膝關節內側間隙關節退變，最終可能發展為膝關節骨性關節炎引起疼痛，引起膝關節外側間隙關節退變，嚴重者需要進行人工關節置換手術。'
                    },
                    risks: [
                        {
                            name: '半月板損傷',
                            des: 'X型腿造成下肢力線發生改變，膝關節外側間隙承受大於正常負荷的壓力。可能引起膝關節外側半月板損傷。'
                        },
                        {
                            name: '關節炎',
                            des: '嚴重X型腿最終可能發展為膝關節骨性關節炎、關節外側間隙關節退變，嚴重者需要進行人工關節\n' +
                                '置換手術。'
                        }
                    ]
                },
                {
                    name: '膝過伸',
                    key: 'kneeOverstretch',
                    normal: {
                        normal: imgSrc.risk_normal.KNEE_OVERSTRETCH
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.KNEE_OVERSTRETCH
                    },
                    definition: '在行走或站立過程中，下肢在支撐期出現膝關節過度伸展（膝伸展角度大於5°），身體重心後移，髖關節過度屈曲，身體出現後傾趨勢的現象。',
                    harm: {
                        bone: '踝關節背屈不足，使膝關節無法向前移動',
                        muscle: '臀大肌薄弱、較多情況下股四頭較肌薄弱，腘繩肌過度活躍，踝關節周圍韌帶緊張、膝關節周圍韌帶及關節囊松弛',
                        neurovascular: '',
                        des: '膝關節伸展受限、膝關節控制能力差、下肢深感覺障礙、異常的運動模式。'
                    },
                    risks: [
                        {
                            name: '膝關節退變',
                            des: '長期膝關節過伸，會引起膝關節的過度磨損，加大膝關節退變的發生率。'
                        },
                        {
                            name: '損害全身平衡',
                            des: '膝關節位置的改變會引起髖關節、骨盆、踝關節的位置異常，由此逐漸損害全身的平衡狀態，長期累積會引發各種體態異常。'
                        }
                    ]
                },
                {
                    name: 'XO型腿',
                    key: 'legXO',
                    normal: {
                        normal: imgSrc.risk_normal.LEG_XO
                    },
                    abnormal: {
                        normal: imgSrc.risk_abnormal.LEG_XO
                    },
                    definition: '股骨、脛骨均呈內旋位，雙側小腿不能並攏。',
                    harm: {
                        bone: '這個是XO型腿',
                        muscle: '這個是XO型腿',
                        neurovascular: '',
                        des: 'XO型腿，股骨、脛骨均呈內旋位，雙側小腿間存在較大間隙，不能並攏，影響美觀。由於股骨與脛骨位置相對不平衡，壓力更易集中在膝關節外側，更易發生膝關節疼痛甚至膝關節炎。'
                    },
                    risks: [
                        {
                            name: '膝關節疼痛',
                            des: '由於XO型腿造成股骨與脛骨位置相對不平衡，壓力更易集中在膝關節外側，更易發生膝關節疼痛。'
                        },
                        {
                            name: '膝關節炎',
                            des: '重度XO型腿最終可能發展為膝關節骨性關節炎。'
                        }
                    ]
                }
            ],
        }
    },
    sympItem: {
        levelName: "高 | 中 | 低"
    },
    sympItemIpad: {
        detection: "檢測到",
        item: "項",
        noHeightRisk: "恭喜您未檢測到高風險，請繼續保持良好的體態",
        otherDetecation: "其他檢測項",
        potentialRisk: "潛在風險",
        heightRisk: "高風險",
        suggest: "平時需要關註自己的體態,並且加強鍛煉",
        suggestSolve:"出現了較明顯的異常體態,需要及時尋求解決方案或是獲取更多專業咨詢",
        normal: "正常",
        risk: "風險",
        levelName: "高 | 中 | 低"
    }


}
export {
    tw
}



// WEBPACK FOOTER //
// ./src/assets/lang.conf/tw.js